/** Enforce authorization even when all audio bytes have already been buffered. */
export function guardAudioLease(audio: HTMLAudioElement, expiresAt: string | null | undefined, onExpired: () => void): () => void {
  let stopped = false;
  let timer: ReturnType<typeof setTimeout>;
  const expiry = Date.parse(expiresAt || '');
  const check = () => {
    if (stopped) return;
    if (!Number.isFinite(expiry) || Date.now() >= expiry) {
      stopped = true;
      audio.pause();
      audio.removeAttribute('src');
      audio.load(); // Discard buffered bytes, including a pending seek.
      onExpired();
      return;
    }
    clearTimeout(timer);
    timer = setTimeout(check, Math.min(expiry - Date.now(), 60_000));
  };
  const invalidate = () => {
    if (stopped) return;
    stopped = true;
    audio.pause(); audio.removeAttribute('src'); audio.load(); onExpired();
  };
  window.addEventListener('luma-access-invalidated', invalidate);
  const events = ['play', 'playing', 'seeking', 'timeupdate'];
  events.forEach((event) => audio.addEventListener(event, check));
  document.addEventListener('visibilitychange', check);
  window.addEventListener('pageshow', check);
  check();
  return () => {
    stopped = true;
    clearTimeout(timer);
    events.forEach((event) => audio.removeEventListener(event, check));
    document.removeEventListener('visibilitychange', check);
    window.removeEventListener('pageshow', check);
    window.removeEventListener('luma-access-invalidated', invalidate);
  };
}
